// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z5hX","field":"styles_field__3IQPw","fieldCol":"styles_fieldCol__3j-bq","diffCol":"styles_diffCol__22Tet","diff":"styles_diff__2PhKN"};